var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.classes,attrs:{"data-element":_vm.checkDataElement(_vm.dataElement),"type":"button","disabled":_vm.disabled},on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }